export const ESTADO_CREADA = 1
export const ESTADO_PUBLICADA = 2
export const ESTADO_PAUSADA = 3
export const ESTADO_ELIMINADA = 4
export const ESTADO_VENCIDA = 5

export const SIN_PREGUNTAS_TEXTO = 'Esta publicación aún no tiene preguntas.'
